import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { FaBookReader, FaArrowRight } from 'react-icons/fa';
import ItemCard from './ItemCard';

const { Title, Paragraph } = Typography;

const coursesData = [
  { id: 1, title: "Machine Learning Basics", description: "Introduction to ML algorithms and models.", duration: "6 Weeks", level: "Beginner", category: "AI & Machine Learning" },
  { id: 2, title: "Deep Learning Specialization", description: "Advanced neural networks and deep learning.", duration: "10 Weeks", level: "Advanced", category: "AI & Machine Learning" },
  { id: 3, title: "Computer Vision", description: "Learn image processing and object detection.", duration: "7 Weeks", level: "Intermediate", category: "AI & Machine Learning" },
  { id: 13, title: "Natural Language Processing with TensorFlow", description: "Build NLP models using TensorFlow.", duration: "8 Weeks", level: "Intermediate", category: "AI & Machine Learning" },
  { id: 7, title: "Data Science Foundations", description: "Statistics, data analysis, and visualization.", duration: "5 Weeks", level: "Beginner", category: "Data Science" },
  { id: 14, title: "Data Visualization with Python", description: "Create visualizations using Python libraries.", duration: "6 Weeks", level: "Intermediate", category: "Data Science" },
  { id: 15, title: "Big Data Analytics", description: "Analyze large datasets with modern tools.", duration: "8 Weeks", level: "Advanced", category: "Data Science" },
  { id: 4, title: "Ethical Hacking", description: "Hands-on ethical hacking training.", duration: "8 Weeks", level: "Intermediate", category: "Cybersecurity" },
];

const CoursesSection = () => (
  <Row gutter={16}>
    <Col span={24}>
      <section style={{ marginBottom: '40px' }}>
        <Title level={2} style={{ fontSize: '18px', display: 'flex', alignItems: 'center', color: '#1890ff' }}>
          <FaBookReader style={{ marginRight: '8px' }} /> Courses
        </Title>
        <Paragraph style={{ fontSize: '14px', color: '#666' }}>
          Explore top-tier courses in AI, Data Science, and Cybersecurity.
        </Paragraph>
        <Row gutter={[16, 16]}>
          {coursesData.slice(0, 4).map((course) => (
            <Col xs={24} sm={12} md={8} lg={6} key={course.id}>
              <ItemCard
                title={course.title}
                description={course.description}
                details={[["Duration", course.duration], ["Level", course.level]]}
                type="courses"
              />
            </Col>
          ))}
        </Row>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/courses">
            <Button type="primary" style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }} aria-label="See all courses">
              See All <FaArrowRight style={{ marginLeft: '8px' }} />
            </Button>
          </Link>
        </div>
      </section>
    </Col>
  </Row>
);

export default CoursesSection;